// import { hot } from 'react-hot-loader/root';
import React from 'react'
import { Router } from 'react-router'
import { createBrowserHistory } from 'history'
import RootContainer from './containers/RootContainer'

const history = createBrowserHistory()

class AdminApp extends React.Component {
    componentDidMount() {
        // const user = this.props
    }

    render() {
        return (
                <Router history={history}>
                    <RootContainer user={this.props.user} />
                </Router>

        )
    }
}

export default AdminApp
